import {httpClient} from "@/Repositories/Indicators/HttpClient";
import {GetIdFromObject} from "@/Repositories/helpers";

export default {

    /**
     * @returns {Promise<*>}
     */
    async getHistoricAcademicPeriods(academicPeriodId) {

        return httpClient.get(route('academic-periods.getHistoric', {academicPeriodId: academicPeriodId}));
    },


}
